module.exports = __webpack_public_path__ + "static/media/harina_atica.b5b4e1b2.png";